// Module
var code = "<div class=\"spond-header-component\"> <div class=\"logo-wrapper\"> <div class=\"logo-img-wrapper\"> <a href=\"/\" tabindex=\"-1\"> <img class=\"spond-logo\" src=\"{{assetSpondLogoUrl}}\" alt=\"SPOND\"> </a> </div> </div> </div> ";
// Exports
export default code;